import React from 'react';
import { Text, View, type StyleProp, type TextStyle, type ViewStyle } from 'react-native';
import { AppPressable } from './AppPressable';

/**
 * Строка ошибки с кнопкой «Повторить» — там, где неудача раньше выглядела пустотой: поиск
 * людей, загрузка чата, список контактов для «Поделиться контактом» (аудит 2026-10-17, UX-44,
 * UX-57, UX-58).
 *
 * <p>Без хуков намеренно: подписи приходят готовыми, и компонент проверяется тестом вызовом
 * функции — рендерера в проекте нет (см. `AppPressable`).
 */
export function InlineRetryError({
  text,
  retryLabel,
  onRetry,
  style,
  textStyle,
  buttonStyle,
  buttonTextStyle,
}: {
  text: string;
  retryLabel: string;
  onRetry: () => void;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  buttonStyle?: StyleProp<ViewStyle>;
  buttonTextStyle?: StyleProp<TextStyle>;
}) {
  return (
    <View style={[{ gap: 8, alignItems: 'flex-start' }, style]} accessibilityLiveRegion="polite">
      <Text style={textStyle}>{text}</Text>
      <AppPressable style={buttonStyle} onPress={onRetry} hitSlop={6} accessibilityRole="button" accessibilityLabel={retryLabel}>
        <Text style={buttonTextStyle}>{retryLabel}</Text>
      </AppPressable>
    </View>
  );
}
